import { render, staticRenderFns } from "./ViewBatch.vue?vue&type=template&id=63d61481&"
import script from "./ViewBatch.vue?vue&type=script&lang=js&"
export * from "./ViewBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports